<template>
  <v-btn
    icon
    variant="text"
    density="comfortable"
    :aria-label="
      qualificationStatus
        ? $t('common:qualifiedIcon.alt')
        : $t('common:notQualifiedIcon.alt')
    "
    @click="$emit('click')"
  >
    <v-icon
      :icon="qualificationStatus ? ' $iconApproved' : '$iconRejected'"
      :color="qualificationStatus ? 'edit-green' : 'red'"
    >
    </v-icon>
  </v-btn>
</template>
<script>
export function qualificationStatusIsQualified(status) {
  return ["COMPLETED", "QUALIFIED_MANUALLY"].includes(status);
}

export default {
  name: "AppShowQualificationStatus",
  props: {
    status: {
      type: String,
      required: true
    },
    showCalculated: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  computed: {
    qualificationStatus() {
      if (this.showCalculated) {
        return ["COMPLETED"].includes(this.status);
      }
      return qualificationStatusIsQualified(this.status);
    }
  }
};
</script>
